import {createActions} from 'client/framework';

export default createActions(null, [
  'SELECTION_START',
  'SELECTION_UPDATE',
  'SELECTION_END',
  'SET_ACTIVE_REGION'
]);
